// Shared between DocumentUploadSlot (profile page), ProfileIdentityCard
// (avatar), and DocumentUploadSection (onboarding) so the upload flows
// can't silently drift apart. Images over MAX_IMAGE_UPLOAD_SIZE_BYTES are
// compressed client-side to fit (see imageCompression.ts) rather than
// rejected outright — PDFs have no client-side compression path, so they're
// just rejected above MAX_PDF_UPLOAD_SIZE_BYTES.
export const MIN_DOCUMENT_UPLOAD_SIZE_BYTES = 50 * 1024;
export const MAX_IMAGE_UPLOAD_SIZE_BYTES = 1024 * 1024;
export const MAX_PDF_UPLOAD_SIZE_BYTES = 2 * 1024 * 1024;
